<template>
  <div class="row group">
    <!--<p v-if="medias && medias[0]" class="subtitle">Вложения ({{medias.length}})</p>-->
    <media-thumb
        v-for="(media, ind) in medias"
        :media="media"
        :key="ind"
        v-on:click.native="$emit('selectMedia',media)"
    />
  </div>
</template>
<style>

</style>
<script>
import MediaThumb from './media-thumb';

export default {
  name: 'mediabar',
  components: { MediaThumb },
  props: {
    medias: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
  },
  /* watch: {
    '$route.query.mid': {
      handler: 'handler2',
      immediate: true,
    },
    medias: {
      handler: 'handler2',
      immediate: true,
    },
  },
  methods: {
    handler2() {
      console.log('HANDLER //////////////////////', this.$route.query.mid, '//', this.medias.length);
      if (this.$route.query.mid && this.medias[0]) {
        const ind = this.medias.findIndex(item => item.id === this.$route.query.mid);
        if (ind > -1) {
          this.$emit('selectMedia', this.medias[ind]);
        }
      }
    },
  }, */
};
</script>



// WEBPACK FOOTER //
// src/components/media-bar.vue